export default __webpack_public_path__ + "static/media/kitchen4-afterF-480w.08881bd1.avif";